import React, { useCallback, useEffect, useRef } from 'react';
import { taxisAdminLogout, taxisLogout } from '../../Services/taxisnet';
import useAuth from '../../Services/useAuth';
import { useNavigate } from 'react-router-dom';

const RedirectHandler = () => {
  const { getRole, logout, isTokenExpired } = useAuth();
  const navigate = useNavigate();
  const hasStarted = useRef(false);

  const role = getRole();

  const logoutTaxisOauth = useCallback(() => {
    if (role === 'admin') {
      taxisAdminLogout();
    } else {
      taxisLogout();
    }
  }, [role]);

  const handleLogout = useCallback(async () => {
    const shouldLogoutTaxis = !isTokenExpired();
    try {
      await logout();
      if (shouldLogoutTaxis) {
        logoutTaxisOauth();
      }

      // Navigate to root as a fallback (may not execute if redirect occurs)
      navigate('/');
    } catch (error) {
      console.log(error);
      navigate('/');
    }
  }, [logout, logoutTaxisOauth, navigate, isTokenExpired]);

  useEffect(() => {
    if (hasStarted.current) return;
    hasStarted.current = true;
    void handleLogout();
  }, [handleLogout]);

  return (
    <div>
      <h1>Έξοδος...</h1>
      <p>Θα ανακατευθυνθείτε σύντομα.</p>
    </div>
  );
};

export default RedirectHandler;
